module.exports = __webpack_public_path__ + "BG-04.2603eca.basis";